import {Brick, registerBrick} from 'olympe';
import BCP from './DM_BCP';

export default class BCPRequestDescription extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {BCP} bcpRequest
     * @param {function(string)} setDescription
     */
    update($, [bcpRequest], [setDescription]) {
        const materialID = bcpRequest.get(BCP.materialIdProp);
        const materialDesc = bcpRequest.get(BCP.materialDescriptionProp);
        const plantID = bcpRequest.get(BCP.plantIdProp);
        const plantDesc = bcpRequest.get(BCP.plantDescriptionProp);
        const requestor = bcpRequest.get(BCP.requestorProp).split(';')[0];
        setDescription(
            `- Requested by: ${requestor}\r
            - Material: ${materialID} ${this.addDashWithString(materialDesc)} \r
            - Plant: ${plantID} ${this.addDashWithString(plantDesc)}`);
    }

    addDashWithString(s) {
        if (s) {
            return `- ${s}`;
        } else {
            return '';
        }
    }
}

registerBrick('01896450c1161feb051d', BCPRequestDescription);
